import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { ConfirmManager, ConfirmOptions } from "./ConfirmManager";
import {
  ConfirmPopupWrapper,
  Backdrop,
  ConfirmContainer,
  ConfirmHeader,
  Title,
  ConfirmBody,
  ConfirmFooter,
} from "./style";
import Button from "components/atoms/Button";
import { COLOR_SYSTEM } from "components/design/design-system";

const ConfirmPopup: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [options, setOptions] = useState<ConfirmOptions | null>(null);

  useEffect(() => {
    const handleChange = (state: { visible: boolean; options: ConfirmOptions | null }) => {
      setVisible(state.visible);
      setOptions(state.options);
    };

    ConfirmManager.addListener(handleChange);
    return () => ConfirmManager.removeListener(handleChange);
  }, []);

  const handleBackdropClick = () => {
    if (options?.backdropClose) {
      ConfirmManager.hide();
    }
  };

  // 보여줄 것이 없으면 아무것도 렌더링하지 않음
  if (!visible || !options) return null;

  // Portal을 사용하여 body에 직접 렌더링
  return ReactDOM.createPortal(
    <ConfirmPopupWrapper>
      <Backdrop showBackdrop={options.showBackdrop !== false} onClick={handleBackdropClick} />
      <ConfirmContainer>
        {options.title && (
          <ConfirmHeader>
            <Title>{options.title}</Title>
          </ConfirmHeader>
        )}
        {options.showCloseButton !== false && (
          <Button
            type="Icon"
            size="Medium"
            variant="Ghost"
            color="Tertiary"
            icon="X"
            style={{ position: "absolute", top: "24px", right: "24px" }}
            onClick={() => ConfirmManager.hide()}
          />
        )}
        <ConfirmBody>{options.body}</ConfirmBody>
        {options.buttons && (
          <ConfirmFooter buttonCount={options.buttons.length}>{options.buttons}</ConfirmFooter>
        )}
      </ConfirmContainer>
    </ConfirmPopupWrapper>,
    document.body
  );
};

export default ConfirmPopup;
